<template>
  <v-dialog v-model="propDialogo" width="400px" persistent>
    <v-card style="padding: 15px">
      <v-icon class="ma-1 right top" style="position: absolute" color="#0D47A1" large
        @click="$emit('closeDialogo')">mdi-close-circle</v-icon>
      <div style="text-align: center; justify-content: center">
        <div class="ml-4 mr-4">
          <h1 style="line-height: 1.2; color: black; text-align: center">
            DETALLES DEL LIBRO
          </h1>
        </div>
          <h3 class="ma-6" style="text-align: left;">
          <span>Titulo: {{ propLibro.titulo }}</span><br>
          <span>Autores: {{ propLibro.autor }}</span><br>
          <a :href="propLibro.enlace" target="_blank" style="color: blue;">
            Abrir enlace de libro
          </a>
        </h3>
        <v-img style="position: relative;  border-radius: 4px;" height="40dvh" contain
          :src="propLibro.imagen_ruta ? `${$env.pathImg}/${propLibro.imagen_ruta}` : require('@/assets/default/book.png')"
          class="center" containt>
          <!-- Loader mientras carga -->
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular indeterminate color="white"></v-progress-circular>
            </div>
          </template>
        </v-img>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
  },
  props: {
    propDialogo: { type: Boolean },
    propLibro: { type: Object }
  },
  data() {
    return {
    };
  },
  mounted() { },
  watch: {},
  methods: {
  },
};
</script>
<style scoped></style>
